var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('v-row',_vm._l((_vm.cards),function(item,i){return _c('v-col',{key:i,attrs:{"cols":_vm.$b({ td: _vm.data.boardType == 2 ? 6 : 3, m: 12 })}},[_c('OfferCard',{attrs:{"card":item,"type":_vm.data.boardType}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }